export default __webpack_public_path__ + "static/media/Marketing.cf5da38a.svg";